"use strict";
var list = { 'travel-money-transfers': 'travelmoneytransfers', sendfx: 'sendfx', sendpayments: 'send' };
var partners = { 'travel-money-transfers': 'Travel Money Transfers', sendfx: 'Send', sendpayments: 'Send' };
var defaultSource = 'sendfx';
var siteMetaList = {
    'travel-money-transfers': {
        title: 'Travel Money Transfers Portal',
    },
    sendfx: {
        title: 'SendFX Portal',
    },
    sendpayments: {
        title: 'Send Portal',
    },
};
module.exports = {
    list: list,
    partners: partners,
    defaultSource: defaultSource,
    siteMetaList: siteMetaList,
};
//# sourceMappingURL=sources.js.map